<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="tonal"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-select
            multiple
            v-model="formData.users"
            :items="users"
            label="المستلمون"
            item-title="fullname"
            item-value="id"
          >
          </v-select>
          <v-textarea
            v-model="formData.text"
            :rules="textRules"
            label="نص الرسالة"
            counter
          ></v-textarea>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["saveFunction", "users", "iconName"],
  data() {
    return {
      isActive: false,
      formData: {
        users: null,
        text: "",
      },
      textRules: [
        (v) => v === null || (v && v.length <= 150) || "too long message",
        (v) => v === null || (v && v.length >= 25) || "too short message",
      ],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData, this.mode);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  computed: {
    title() {
      return "رسالة جديدة";
    },
  },
};
</script>
